export const business = {
  name: 'Alma Yoga',
  url: 'https://almayoga.nyc',
  phoneDisplay: '+1 (917) 805-4352',
  phoneHref: 'tel:+19178054352',
  email: 'hello@almayoga.nyc',
  whatsapp: 'https://wa.me/19178054352',
  instagram: 'https://instagram.com/almayoga.nyc',
  instagramHandle: '@almayoga.nyc',
};
